/** API 호출 실패를 한 가지 형태로 통일한다. UI 는 message 와 status 만 본다. */
export class ApiError extends Error {
  constructor(message, { status = 0, code = 'ERROR', details = null } = {}) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
  }
}

export const isApiError = e => e instanceof ApiError;

/** 어떤 예외든 사람이 읽을 메시지로. */
export function errorMessage(e, fallback = 'Something went wrong. Please try again.') {
  if (!e) return fallback;
  if (typeof e === 'string') return e;
  if (e.message) return e.message;
  return fallback;
}
